export default __webpack_public_path__ + "static/BSI-7260f89df706cf40aa38fe3231fe855c.png";